var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_850_3319)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 58,
    fill: "url(#paint0_radial_850_3319)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6 89.1999L51.94 88.7259L67.98 58.2979L68.014 57.9759L60.944 44.6959C60.8146 44.453 60.6121 44.257 60.3651 44.1356C60.1182 44.0142 59.8393 43.9735 59.5679 44.0193C59.2966 44.065 59.0465 44.195 58.853 44.3907C58.6596 44.5864 58.5326 44.838 58.49 45.1099L51.6 89.1999Z",
    fill: "#FFC24A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8 88.8404L52.056 88.3404L67.93 58.2284L60.878 44.8964C60.7617 44.6645 60.5734 44.4766 60.3413 44.3607C60.1093 44.2449 59.8459 44.2073 59.5907 44.2537C59.3355 44.3001 59.1022 44.428 58.9258 44.6181C58.7493 44.8082 58.6392 45.0504 58.612 45.3084L51.8 88.8404Z",
    fill: "#FFA712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.168 68.0204L78.432 62.6204L73.166 52.5784C73.0501 52.3623 72.8778 52.1817 72.6673 52.0557C72.4569 51.9298 72.2162 51.8633 71.971 51.8633C71.7258 51.8633 71.4851 51.9298 71.2747 52.0557C71.0642 52.1817 70.8919 52.3623 70.776 52.5784L67.962 57.9424V58.4004L73.168 68.0204Z",
    fill: "#F4BD62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.074 67.8004L78.192 62.5604L73.074 52.8004C72.9902 52.5892 72.8471 52.4067 72.662 52.2749C72.4768 52.1431 72.2575 52.0677 72.0304 52.0578C71.8034 52.0478 71.5783 52.1038 71.3824 52.2189C71.1864 52.334 71.0279 52.5033 70.926 52.7064L68.098 58.1644L68.014 58.4424L73.074 67.8004Z",
    fill: "#FFA50E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.604 89.2021L51.758 89.0461L52.316 88.8201L72.836 68.3761L73.096 67.6681L67.978 57.9121L51.604 89.2021Z",
    fill: "#F6820C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.824 99.5117L92.4 89.1537L87.092 56.4917C87.0539 56.2614 86.9532 56.0461 86.8008 55.8694C86.6484 55.6926 86.4502 55.5613 86.2281 55.4898C86.0059 55.4183 85.7684 55.4094 85.5415 55.464C85.3146 55.5187 85.1072 55.6348 84.942 55.7997L51.6 89.1997L70.066 99.5097C70.6401 99.83 71.2866 99.9982 71.944 99.9982C72.6014 99.9982 73.2479 99.83 73.822 99.5097",
    fill: "#FDE068"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.23 89.068L86.966 56.652C86.9567 56.4318 86.8823 56.2192 86.7522 56.0413C86.622 55.8634 86.4421 55.7281 86.235 55.6525C86.0279 55.5769 85.8031 55.5645 85.589 55.6167C85.3748 55.6689 85.181 55.7835 85.032 55.946L51.8 89.138L70.062 99.338C70.6315 99.6557 71.2728 99.8225 71.925 99.8225C72.5772 99.8225 73.2185 99.6557 73.788 99.338L92.23 89.068Z",
    fill: "#FCCA3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.824 99.2C73.2499 99.5204 72.6034 99.6885 71.946 99.6885C71.2886 99.6885 70.6421 99.5204 70.068 99.2L51.752 89.044L51.6 89.2L70.066 99.51C70.6401 99.8304 71.2866 99.9985 71.944 99.9985C72.6014 99.9985 73.2479 99.8304 73.822 99.51L92.4 89.154L92.354 88.874L73.824 99.2Z",
    fill: "#EEAB37"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_850_3319",
    x: 0,
    y: 0,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_850_3319"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_850_3319",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72 72) rotate(85.4261) scale(54.5487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCCA3F",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.5035099ba6d928c4dfe94f42a4c02ee2.svg";
export { ForwardRef as ReactComponent };